"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableDataXtokens = getTableDataXtokens;
exports.getUnlocksData = getUnlocksData;
const client_js_1 = require("../client.js");
const decimal_js_1 = require("decimal.js");
const getReceipts_js_1 = require("./getReceipts.js");
async function getTableDataXtokens(owner, table) {
    let locked_alpha_pos_arr = [];
    const suiClient = (0, client_js_1.getSuiClient)();
    let currentCursor = null;
    do {
        const response = await suiClient.getDynamicFields({
            parentId: table,
            cursor: currentCursor,
        });
        locked_alpha_pos_arr = locked_alpha_pos_arr.concat(response.data);
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            break;
        }
    } while (true);
    if (locked_alpha_pos_arr.length > 0) {
        const promises = locked_alpha_pos_arr.map(async (locked_obj) => {
            const locked_item1 = await suiClient.getDynamicFieldObject({
                parentId: table,
                name: locked_obj.name,
            });
            if (locked_item1 && locked_item1.data) {
                const locked_item_object = locked_item1.data;
                const value = locked_item_object.content.fields.value.fields.value;
                return {
                    value: value,
                    timestamp: locked_item_object.content.fields.name,
                };
            }
            // If no data, return undefined or handle as needed
            return undefined;
        });
        const results = (await Promise.all(promises)).filter((result) => result !== undefined);
        const unlocks = results.map((o) => {
            return {
                address: owner,
                timestampMs: Number(o.timestamp),
                tokens: o.value,
            };
        });
        return unlocks;
    }
    return undefined;
}
async function getUnlocksData(owner_table) {
    let allUnlocksData = [];
    const alphaExchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)("ALPHA", true);
    for (const entry of owner_table) {
        const [owner, table] = entry;
        const unlocksXtokens = await getTableDataXtokens(owner, table);
        if (unlocksXtokens) {
            const unlocks = unlocksXtokens?.map((o) => {
                const tokens = new decimal_js_1.Decimal(o.tokens)
                    .mul(alphaExchangeRate)
                    .div(1e9)
                    .toString();
                return {
                    address: o.address,
                    timestampMs: o.timestampMs,
                    tokens: tokens,
                };
            });
            allUnlocksData = allUnlocksData.concat(unlocks);
        }
    }
    return allUnlocksData;
}
//# sourceMappingURL=fetchTableData.js.map